import { homeServerUrl } from "../environment/Environment"
import axiosInstance from "../external-library/axios-interceptor/Interceptor"

export const doLogin = async (userDetails) => {
    return await axiosInstance.post(`${homeServerUrl}/Login/Login`, userDetails)
}

export const doRegistration = async (userDetails) => {
    return await axiosInstance.post(`${homeServerUrl}/Login/Register`, userDetails)
}